import { render, staticRenderFns } from "./CopyEventModal.vue?vue&type=template&id=481b670e&scoped=true"
import script from "./CopyEventModal.vue?vue&type=script&lang=js"
export * from "./CopyEventModal.vue?vue&type=script&lang=js"
import style0 from "./CopyEventModal.vue?vue&type=style&index=0&id=481b670e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481b670e",
  null
  
)

export default component.exports